"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function capitalize(str) {
    const words = str.split(' ');
    words.forEach((item, index) => {
        if (!item.length)
            return;
        words[index] = item.replace(item[0], item[0].toUpperCase());
    });
    return words.join(' ');
}
exports.default = capitalize;
//# sourceMappingURL=capitalize.js.map